import { useField } from 'formik';
import React from 'react';
import { injectIntl } from 'react-intl';
import { formatMessage } from '../../translations/format-message';
import FormikFormErrorHandler from './FormikFormErrorHandler';

type Option = {
  id: number;
  value: string;
  disabled: boolean;
};

interface IProps {
  getData?: boolean;
  children: React.ReactNode;
  className: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  validcharacter?: Array<string>;
  invalidcharacter?: Array<string>;
  options: Option[];
  // Optional map of option.value -> already-localized display text. When a
  // field's options are driven by a server-side field configuration (rather
  // than a static translation-key list), this lets the option render that
  // text directly instead of looking value up as a translation key.
  labels?: Record<string, string>;
  id: string;
  stopTranslation?: boolean;
}

const FormikFormSelect = (props: IProps) => {
  const { name, options, disabled, labels } = props;
  const [field, meta]: any = useField(props);
  const errorClass = `${meta.error && meta.touched ? 'error' : ''}`;

  return (
    <>
      <select
        name={name}
        {...field}
        className={props.className + ' ' + errorClass}
        data-testid={props.id ? props.id : undefined}
        disabled={props.disabled}
        onChange={props.onChange}
      >
        {options?.map((data: Option, i: number) => (
          <option
            key={i}
            value={props.getData === true ? data.value : data.id}
            id={
              props.getData === true
                ? data.value.toString()
                : data.id.toString()
            }
            disabled={data.disabled}
          >
            {labels?.[data.value] ?? ((props.stopTranslation && data.id > 0) ? data.value : formatMessage(data.value))}
          </option>
        ))}
      </select>
      <FormikFormErrorHandler
        intl={props.intl}
        meta={meta}
      />
    </>
  );
};

export default injectIntl(FormikFormSelect);
